<template>
    <div>
        <div style="margin-top: 2rem;">
            <contact-header-vertical :contact="conversation.contact"></contact-header-vertical>
            <hr>

            <div class="card" style="background-color: white; padding: 0; margin-bottom: 1rem;">
                <ui-collapsible title="Diary" style="margin: 0;" open>
                    <activities-pane
                        ref="activities"
                        :contact="conversation.contact"
                        :lead="currentLead"
                        @updated="e => { this.$refs.leads.load() }"></activities-pane>
                </ui-collapsible>
            </div>

            <div class="card" style="background-color: white; padding: 0; margin-bottom: 1rem;">
                <ui-collapsible title="Leads" class="leads-collapsible" open>
                    <lead-summary-pane
                        ref="leads"
                        summary-type="contact"
                        :summary-for="conversation.contact"
                        @updated="reloadActivities()"
                        :lead-defaults="{ conversation_id: conversation.id }"
                    ></lead-summary-pane>
                </ui-collapsible>
            </div>
        </div>
    </div>
</template>

<script>
    import ActivitiesPane from "./ActivitiesPane";
    import ContactHeaderVertical from "../elements/ContactHeaderVertical";
    import LeadSummaryPane from "../lead/LeadSummaryPane";
    export default {
        components: {LeadSummaryPane, ContactHeaderVertical, ActivitiesPane},
        props: {
            conversation: {
                type: Object,
                required: true,
            }
        },
        created() {
            setInterval(() => {
                if (this.$refs.leads && this.$refs.leads.leads.length === 1) {
                    this.currentLead = this.$refs.leads.leads[0]
                } else {
                    this.currentLead = null
                }
            }, 100)
        },
        data() {
            return {
                currentLead: null
            }
        },
        methods: {
            gotoContact() {
                this.$root.navigateTo('contacts/' + this.conversation.contact_id)
            },
            triggerUpdate() {
                this.$emit('updated')
            },
            reloadActivities() {
                if (this.$refs.activities) {
                    this.$refs.activities.load()
                }
            }
        },
        watch: {
            conversation() {
                this.$refs.activities.load()
                this.$refs.leads.load()
            }
        }
    }
</script>

<style lang="scss" scoped>
    h1 {
        cursor: pointer;
        &:hover { text-decoration: underline; }
    }
</style>

<style lang="scss">
    .leads-collapsible {
        margin-bottom: 0 !important;

        .ui-collapsible__body {
            padding: .5rem .5rem 0;
        }
    }
</style>